import React from 'react';
import { Alert } from '@ast/magma/components/alert';
import { useFISettingsContext } from '@app/core/contexts/fiSettings/FISettingsContext';
import { t } from '@app/core/i18n';

import styles from './ContactUsAlert.pcss';

/**
 * @todo make able to recieve localization from outside
 */
export const ContactUsAlert: React.FC = () => {
  const fiSettings = useFISettingsContext();
  const supportUrl = fiSettings?.getIfConfigured('customerHelpCenterUrl');

  return (
    <Alert level="info" data-stable-name="AlertTrans">
      {
        t('contact-alert.message|Contact Us alert message',
          "Don't have this information? <a {{options}} {{href}} {{className}}>Contact us</a> for help.",
          {
            options: "target='_blank' rel='noopener noreferrer nofollow'",
            href: supportUrl ? `href="${supportUrl}"` : '',
            className: `className="${styles.link}"`,
          })
      }
    </Alert>
  );
};
